import Controller from '@ember/controller';
import clsx from 'clsx';

class PeopleCenterController extends Controller {
  get peopleCenterBodyClasses() {
    return clsx(
      'SH-r-people-center',
      'lsg',
      'has-performed-a-search',
    );
  }
}

export default PeopleCenterController;
